export default function getFormattedAddress(reviewRecord) {
	let formattedAddress = "";
	if (!!reviewRecord.organization_address) {
		formattedAddress += " " + reviewRecord.organization_address;
	}
	if (!!reviewRecord.organization_city) {
		formattedAddress += " " + reviewRecord.organization_city;
	}
	if (!!reviewRecord.organization_postal) {
		formattedAddress += " " + reviewRecord.organization_postal;
	}

	return formattedAddress === "" ? null : formattedAddress;
}

export function getFormattedAddressFromOrganization(reviewRecord) {
	let formattedAddress = reviewRecord.address;
	formattedAddress += " " + reviewRecord.city;
	formattedAddress += " " + reviewRecord.postal;

	return formattedAddress;
}



// WEBPACK FOOTER //
// ./src/utils/reviews/addresses.js